import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=3c4bc0fa&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CASADEDIOS\\git\\global_business\\gpb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4bc0fa')) {
      api.createRecord('3c4bc0fa', component.options)
    } else {
      api.reload('3c4bc0fa', component.options)
    }
    module.hot.accept("./RegisterForm.vue?vue&type=template&id=3c4bc0fa&", function () {
      api.rerender('3c4bc0fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/frontend/js/components/RegisterForm.vue"
export default component.exports